<div id="content-root" class="mobile">
    <div id="content-column">
        <div id="header-div"></div>
        <div id="main-div"></div>
    </div>
</div>